<script>
	import OffsetThresholdWrapperGBLE from './OffsetThresholdWrapperGBLE.svelte';

	export let device;
</script>

<OffsetThresholdWrapperGBLE {device} setting="threshold" type="smoke" min={0} max={60} />
